// Fluent send_clock_24_regular (MIT) — a payment request sent, immediately or on a
// schedule. Vendored as a path so no icon package is pulled in. Fill-based, so it colours
// from `fill` (defaults to currentColor; the suggestion tile passes the brand gradient).
const PATH =
  "M2.29933 3.27174L5.69362 11.9999L2.29933 20.7281L2.2688 20.8237C2.11746 21.4262 2.75077 21.9622 3.33375 21.6707L11.0084 17.8334C11.0028 17.7229 11 17.6118 11 17.4999C11 17.0133 11.0535 16.5392 11.1549 16.0831L4.4021 19.4595L7.01109 12.7493L13.063 12.7499C13.4543 12.3842 13.8908 12.0663 14.3632 11.8055C14.2776 11.4855 13.9856 11.2499 13.6387 11.2499L7.01109 11.2493L4.4021 4.54032L17.3259 11.0022C17.3837 11.0007 17.4418 10.9999 17.5 10.9999C19.0533 10.9999 20.4793 11.5448 21.5975 12.4538C21.8648 12.1015 21.7769 11.5507 21.3337 11.3291L3.33375 2.32909L3.2414 2.28983C2.65544 2.08334 2.0631 2.66427 2.29933 3.27174ZM23 17.5C23 14.4624 20.5376 12 17.5 12C14.4624 12 12 14.4624 12 17.5C12 20.5376 14.4624 23 17.5 23C20.5376 23 23 20.5376 23 17.5ZM17.5 14C17.7761 14 18 14.2239 18 14.5V17H20C20.2761 17 20.5 17.2239 20.5 17.5C20.5 17.7761 20.2761 18 20 18H17.5C17.2239 18 17 17.7761 17 17.5V14.5C17 14.2239 17.2239 14 17.5 14Z";

export default function SendClockIcon({
  className = "size-5",
  fill = "currentColor",
  ...props
}) {
  return (
    <svg viewBox="0 0 24 24" fill={fill} aria-hidden="true" className={className} {...props}>
      <path d={PATH} />
    </svg>
  );
}
